import { render, staticRenderFns } from "./group-header.vue?vue&type=template&id=67099687&"
import script from "./group-header.vue?vue&type=script&lang=js&"
export * from "./group-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports